import api from "@/api";
import { PageModel, ScheduleModel, ScheduleRequest } from "../types";

export default class ScheduleApi {
  static async list(data: ScheduleRequest): Promise<PageModel<ScheduleModel>> {
    return await api.get(`schedules`, data);
  }

  static async single(id: string) {
    return await api.get(`schedules/${id}`);
  }

  static async create(data: ScheduleModel) {
    return await api.post(`schedules`, data);
  }

  static async update(data: ScheduleModel) {
    return await api.put(`schedules/${data.id}`, data);
  }

  static async delete(id: string) {
    return await api.del(`schedules/${id}`);
  }
}
